import { Icon, KeyValueCustomSelect } from "@smartsuite/react-ui/lib";
import type { FC, ReactNode } from "react";
import { useEffect, useState } from "react";
import { useTheme } from "../../../../../../../../../stores";
import { useRootStore } from "../../../../../../../../../stores/hooks";
import { getLocalCssColorVariables } from "../../../../../../../../../utils/cssVariablesUtils";
import * as S from "./style";
import { buildTimeOptions } from "./time-options";
import { unknown } from "zod";
import SvgDueDate from "../../../../../../../../../../generated/images/DueDate";
import { t } from "i18next";

interface Props {
  onChange: (value: number | undefined) => void;
  time?: number;
  disabled?: boolean;
  isSet: boolean;
}

/* eslint-disable  @typescript-eslint/no-explicit-any */
const renderOption = (option: Record<any, any>): ReactNode => {
  return option.value === undefined ? (
    <S.OptionEmpty className="default-option">
      <SvgDueDate />
      <p
        className="text text--ellipsis text--m text--transition medium currentColor"
        role="paragraph"
      >
        {option.label}
      </p>
    </S.OptionEmpty>
  ) : (
    <div className="default-option">
      <p
        className="text text--ellipsis text--m text--transition medium currentColor"
        role="paragraph"
      >
        {option.label}
      </p>
    </div>
  );
};

/* eslint-disable  @typescript-eslint/no-explicit-any */
const renderSelectedOption = (
  option: Record<any, any>,
  onRemove: () => void,
): ReactNode => {
  return option.value === undefined ? (
    <div className="field-type-pill is-removable" role="button">
      <SvgDueDate style={{ marginRight: "10px" }} />
      <span
        className="text text--ellipsis text--m text--transition medium currentColor"
        role="paragraph"
      >
        {option.label}
      </span>
      <button
        type="button"
        onClick={onRemove}
        className="field-type-pill__remove"
      >
        <Icon name="close-1px" size="S" color="currentColor" transition />
      </button>
    </div>
  ) : (
    <div className="default-option">
      <span
        className="text text--ellipsis text--m text--transition medium currentColor"
        role="paragraph"
      >
        {option.label}
      </span>
    </div>
  );
};

export const TimeEditor: FC<Props> = ({ onChange, time, disabled, isSet }) => {
  const theme = useTheme();
  const { config } = useRootStore();
  const [open, setOpen] = useState<boolean>(false);
  const [timeAvailable, setTimeAvailable] = useState<boolean>(isSet);

  const [value, setValue] = useState<number | undefined>(time);

  useEffect(() => {
    setValue(time);
  }, [time]);

  const onOpenChange = (e: boolean): void => {
    setOpen(e);
  };

  useEffect(() => {
    setTimeAvailable(isSet);
  }, [isSet, time]);

  const onRemove = (): void => {
    setTimeAvailable(false);
  };

  return (
    <S.Wrapper>
      <S.StyledTitle>at</S.StyledTitle>
      <S.MinWidthSelector>
        <KeyValueCustomSelect
          my="left top+2"
          value={timeAvailable ? value : unknown}
          showClear={false}
          placeholderArrowStyle="filled"
          state={open ? "active" : "default"}
          options={buildTimeOptions(config.userPreferences, true)}
          className={`dropdown-panel-min-width ${
            open ? "container-is-open" : ""
          }`}
          portalStyles={getLocalCssColorVariables(theme)}
          onOpenedChange={onOpenChange}
          // minWidth={284}
          onChange={(value) => {
            onChange(value as number);
          }}
          showFilter={false}
          disabled={!!disabled}
          renderOption={renderOption}
          renderSelectedOption={(option) =>
            renderSelectedOption(option, onRemove)
          }
          placeholder={
            open ? t("automation-form.time-field-placeholder") : "\u00a0"
          }
        />
      </S.MinWidthSelector>
    </S.Wrapper>
  );
};
